import { Route } from 'types/route.type';
import EditPlant from './components/edit-plant';
import ListPlants from './list-plants';

export const routes: Route[] = [
  {
    path: '/feed-management/plants',
    component: ListPlants,
    id: 'feedManagement.navigation.listPlants',
  },
  {
    path: '/feed-management/plants/:code',
    component: EditPlant,
  },
];
